import React, { useCallback, useMemo } from 'react';
import {
  loadPageRequest,
  popAdminModal,
  popAdminPanel,
} from '../../../actions';
import { getMessenger } from '../messenger';
import { AdminDiscardPageDraftModalProps } from './admin-discard-page-draft-modal-props';
import { AdminModal } from '../admin-modal';
import { AdminModalBody } from '../admin-modal-body';
import { AdminModalButtonFooter } from '../admin-modal-button-footer';
import { AdminModalHeader } from '../admin-modal-header';
import { AdminModalHeading } from '../admin-modal-heading';
import { AdminModalText } from '../admin-modal-text';
import { Button } from '@mint/ui';
import { goBack } from 'connected-react-router';
import { useDeletePageMutation } from '../../../mutations';
import { useDispatch } from 'react-redux';

export const AdminDiscardPageDraftModal: React.FunctionComponent<
  AdminDiscardPageDraftModalProps
> = props => {
  const dispatch = useDispatch();

  const [deletePage] = useDeletePageMutation({
    id: props.pageId,
  });

  const messenger = useMemo(getMessenger, []);

  const onDeleteClick = useCallback(async () => {
    if (props.deletePage) {
      await deletePage();
    }
    if (props.popAdminPanel) {
      dispatch(popAdminPanel());
    }
    messenger.send('discard_draft');
    dispatch(popAdminModal());
    dispatch(loadPageRequest(props.pageId));
    dispatch(goBack());
  }, [deletePage, props.deletePage, props.popAdminPanel]);

  const onCancelClick = useCallback(() => {
    dispatch(popAdminModal());
  }, [dispatch]);

  return (
    <AdminModal>
      <AdminModalHeader>
        <AdminModalHeading>Discard Draft</AdminModalHeading>
      </AdminModalHeader>
      <AdminModalBody>
        <AdminModalText>
          {props.pageTitle ? (
            <>
              Are you sure you want to discard this draft for{' '}
              <b>{props.pageTitle}</b>?
            </>
          ) : (
            'Are you sure you want to discard this page draft?'
          )}
        </AdminModalText>
      </AdminModalBody>
      <AdminModalButtonFooter>
        <Button onClick={onCancelClick}>Cancel</Button>
        <Button onClick={onDeleteClick} color="error">
          Yes, Discard Draft
        </Button>
      </AdminModalButtonFooter>
    </AdminModal>
  );
};
